export const DD_APP_ID =
  process.env.DATADOG_APP_ID ?? 'e753a6ff-83ee-45bd-95b2-9b04770e32ed';
export const DD_CLIENT_TOKEN =
  process.env.DATADOG_CLIENT_TOKEN ?? 'pubfb82f2d5a3b9c0fb99b4d6ab0c6c102b';
export const DD_PROXY = process.env.DATADOG_PROXY ?? 'https://rp.influitives.com/';
export const DEPLOY_ENV = process.env.DEPLOY_ENV ?? 'development';
